// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_container__rP2tI","loader":"loader__vk0Vd","spin":"spin__kXd0y"};